var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "admin-page" }, [
    _c("div", { staticClass: "main-cnt" }, [
      _c("div", { staticClass: "content-white" }, [
        _c("div", { staticClass: "content-body" }, [
          _c("div", { staticClass: "box-content" }, [
            _c(
              "form",
              {
                staticClass: "form-group",
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                    return _vm.setInfos.apply(null, arguments)
                  }
                }
              },
              [
                _c("div", { staticClass: "d-flex mb-4" }, [
                  _c("div", { staticClass: "pr-2 w-165" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-pink-53 w-100",
                        attrs: { type: "submit" }
                      },
                      [
                        _vm._v(
                          "\n                                    " +
                            _vm._s(_vm.$t("button.ok")) +
                            "\n                                "
                        )
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-group-input-vc row-info form-input" },
                  [
                    _c("label", { staticClass: "row-lb font500" }, [
                      _vm._v(
                        "\n                                " +
                          _vm._s(_vm.$t("company.general.full_name")) +
                          "\n                            "
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "info-input-company" },
                      [
                        _c("select2", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate.disable",
                              value: "required",
                              expression: "'required'",
                              modifiers: { disable: true }
                            }
                          ],
                          attrs: {
                            id: "searchCompanyId",
                            name: "companyId",
                            options: _vm.companySelectOptions,
                            settings: _vm.companySelectSettings
                          },
                          on: {
                            change: function($event) {
                              return _vm.companySelectChangeEvent($event)
                            },
                            select: function($event) {
                              return _vm.companySelectEvent($event)
                            }
                          },
                          model: {
                            value: _vm.companyId,
                            callback: function($$v) {
                              _vm.companyId = $$v
                            },
                            expression: "companyId"
                          }
                        })
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "form-group-input-vc row-info" }, [
                  _c("label", { staticClass: "row-lb font500" }, [
                    _vm._v(
                      "\n                                " +
                        _vm._s(_vm.$t("notify.title")) +
                        "\n                            "
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row-cnt" }, [
                    _c("div", { staticClass: "lst-type w-100" }, [
                      _c(
                        "ul",
                        { staticClass: "row no-gutters" },
                        _vm._l(_vm.showInfos, function(s) {
                          return _c(
                            "li",
                            {
                              key: s.id,
                              staticClass: "col",
                              attrs: { value: s.id },
                              on: {
                                click: function($event) {
                                  return _vm.changeShowInfos(s.id)
                                }
                              }
                            },
                            [
                              _c("div", {
                                staticClass: "type-txt",
                                class: { active: _vm.selectedId == s.id },
                                domProps: { innerHTML: _vm._s(s.name) }
                              })
                            ]
                          )
                        }),
                        0
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group-input-vc row-info" }, [
                  _c("label", { staticClass: "row-lb font500" }, [
                    _vm._v(
                      "\n                                " +
                        _vm._s(_vm.$t("notify.header")) +
                        "\n                            "
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row-cnt" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.infos.title,
                          expression: "infos.title"
                        },
                        {
                          name: "validate",
                          rawName: "v-validate.disable",
                          value: "required|max:255",
                          expression: "'required|max:255'",
                          modifiers: { disable: true }
                        }
                      ],
                      key: "title",
                      staticClass: "form-control",
                      attrs: {
                        type: "text",
                        autocomplete: "off",
                        name: "title",
                        "data-vv-as": _vm.$t("notify.header"),
                        disabled: !_vm.isShowInfo
                      },
                      domProps: { value: _vm.infos.title },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.infos, "title", $event.target.value)
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.errors.has("title"),
                            expression: "errors.has('title')"
                          }
                        ],
                        staticClass: "error-text"
                      },
                      [_vm._v(_vm._s(_vm.errors.first("title")))]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group-input-vc row-info" }, [
                  _c("label", { staticClass: "row-lb font500" }, [
                    _vm._v(
                      "\n                                " +
                        _vm._s(_vm.$t("notify.body")) +
                        "\n                            "
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row-cnt" }, [
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.infos.body,
                          expression: "infos.body"
                        },
                        {
                          name: "validate",
                          rawName: "v-validate.disable",
                          value: "required|max:255",
                          expression: "'required|max:255'",
                          modifiers: { disable: true }
                        }
                      ],
                      staticClass: "form-control",
                      staticStyle: { height: "10rem" },
                      attrs: {
                        name: "body",
                        "data-vv-as": _vm.$t("notify.body"),
                        disabled: !_vm.isShowInfo
                      },
                      domProps: { value: _vm.infos.body },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.infos, "body", $event.target.value)
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.errors.has("body"),
                            expression: "errors.has('body')"
                          }
                        ],
                        staticClass: "error-text"
                      },
                      [_vm._v(_vm._s(_vm.errors.first("body")))]
                    )
                  ])
                ])
              ]
            )
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4f404d7d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f404d7d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/admin/InfoManagement/List.vue
// module id = null
// module chunks = 